// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon___1QXlp","no-public":"no-public___qqGNe"};